import { createContext, useContext } from "react";
import type { FlagName, FlagOverrides } from "./feature-flag-overrides";
import type { FeatureFlags } from "./featureFlags";

type FeatureFlagContextType = {
  featureFlags?: FeatureFlags;
  serverFlags?: FeatureFlags;
  isLoading: boolean;
  isError: boolean;
  overrides: FlagOverrides;
  setOverride: (name: FlagName, enabled: boolean | null) => void;
  clearOverrides: () => void;
};

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  isLoading: true,
  isError: false,
  overrides: {},
  setOverride: () => undefined,
  clearOverrides: () => undefined,
});

export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error(
      "useFeatureFlagContext must be used within a FeatureFlagProvider",
    );
  }
  return context;
};
